module.exports = __webpack_public_path__ + "img/brasao-executiva.d032e398.png";